import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-shared-accordion-item',
  templateUrl: './shared-accordion-item.component.html',
  styleUrls: ['./shared-accordion-item.component.scss'],
  standalone: false,
})
export class SharedAccordionItemComponent {

  @Input() canToggle = true;
  @Input() isOpen = false;
  @Input() class?: string;
  @Input() id?: string | number;
  @Output() readonly accordionHeaderClicked = new EventEmitter<boolean>();

  toggle(): void {
    this.isOpen = !this.isOpen;
    this.accordionHeaderClicked.emit(this.isOpen);
  }

}

